module.exports = __webpack_public_path__ + "static/img/Page1.e02d213.png";